/**
 * Centralized storage keys to avoid magic strings
 */
export const STORAGE_KEYS = {
	// Local Storage - Encrypted
	ENCRYPTED_BACKUP: "encryptedBackup",
	CLOUD_BACKUP_STALE: "cloud-backup-stale",
	NEW_WALLET_CLOUD_BACKUP_PENDING: "new-wallet-cloud-backup-pending",
	CURRENT_IDENTITY: "sigma-current-identity",

	// Local Storage - PRF Encrypted (WebAuthn biometric)
	PRF_ENCRYPTED_BACKUP: "prf-encrypted-backup", // PRF-encrypted backup envelope
	PRF_CREDENTIAL_ID: "prf-credential-id", // WebAuthn credential ID for PRF auth
	PRF_SALT: "prf-salt", // PRF salt for WebAuthn key derivation (base64)
	PRF_ENCRYPTED_ACTIVE_ACCOUNT: "prf-encrypted-active-account", // PRF-encrypted { wif, id } for iframe access

	// Session Storage - Decrypted
	DECRYPTED_BACKUP: "decryptedBackup",
	ACTIVE_ACCOUNT: "sigma-active-account", // { wif, id } for the selected identity
	OAUTH_SIGNUP_INFO: "oauthSignupInfo",
	OAUTH_LINKING: "oauth_linking",
	PENDING_OAUTH_LINK: "pendingOAuthLink",
	PENDING_BACKUP: "pending-backup",
	PENDING_IMPORT_BACKUP: "pending-import-backup",
	// Display name (and bio) captured by the signup form, consumed by the
	// post-sign-in identity registration. The value must stay exactly
	// "INITIAL_PROFILE_DATA" — existing browsers already store it under it.
	INITIAL_PROFILE_DATA: "INITIAL_PROFILE_DATA",
	// Set when a pre-0.3 legacy backup is upgraded/reissued during sign-in.
	// Holds the re-encrypted backup so a persistent banner on the destination
	// page (onboarding/account) can offer the download — the login-page toast
	// is destroyed by the post-sign-in hard navigation (OPL-2518).
	// Also carries public old->new BAP ID mappings so dependent server rows can
	// be recovered after the new identities are registered.
	REISSUED_BACKUP: "reissued-backup",
	TEMP_PASSWORD: "temp-password", // Temporary password storage during sign-in flow only
	// Per-profile dismissal of the "claim your handle" prompt on the account
	// page. Suffixed with the bapId, so dismissing it for one profile does not
	// hide it for another.
	HANDLE_PROMPT_DISMISSED: "brc169-handle-prompt-dismissed",
	// BRC-169 section 5.5 rule 3: the user's alias pins, `{ alias: domain }`.
	// A pin overrides the conflict ordering rule and is never a grant of
	// authority — a pinned domain still has to produce a valid advertisement.
	BRC169_ALIAS_PINS: "brc169-alias-pins",
	// Sign-in page memory for this device: which tab was open last and which
	// method the user last successfully completed. Convenience only; never authority.
	LOGIN_LAST_TAB: "login-last-tab",
	LOGIN_LAST_METHOD: "login-last-successful-method",
} as const;
